import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue'
import DashboardPage from '../pages/DashboardPage.vue'
import { getAuthToken } from '../services/authToken'
import OrderPage from '../pages/OrderPage.vue'
import OrderProcessingPage from '../pages/OrderProcessingPage.vue'
import DebugPage from '../pages/DebugPage.vue'
import ScannerFocusDebugPage from '../pages/ScannerFocusDebugPage.vue'
import PaddingDebugPage from '../pages/PaddingDebugPage.vue'
import SalePage from '../pages/SalePage.vue'
import NewSalePage from '../pages/NewSalePage.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', name: 'login', component: LoginPage },
    { path: '/debug-input', name: 'debug-input', component: DebugPage },
    { path: '/debug-scanner', name: 'debug-scanner', component: ScannerFocusDebugPage },
    { path: '/debug-padding', name: 'debug-padding', component: PaddingDebugPage },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
      meta: { requiresAuth: true },
    },
    {
      path: '/orders/:id',
      name: 'order',
      component: OrderPage,
      meta: { requiresAuth: true, title: 'order-title' },
      props: (route) => ({ id: String(route.params.id) }),
    },
    {
      path: '/new-sale',
      name: 'new-sale',
      component: NewSalePage,
      meta: { requiresAuth: true, title: 'sale-title' },
      props: (route) => ({ id: String(route.params.id) }),
    },
    {
      path: '/sales/:id',
      name: 'sale',
      component: SalePage,
      meta: { requiresAuth: true, title: 'sale-title' },
      props: (route) => ({ id: String(route.params.id) }),
    },
    {
      path: '/order-processing/:id',
      name: 'order-processing',
      component: OrderProcessingPage,
      meta: { requiresAuth: true, title: 'order-details-title', noLogout: true },
      props: (route) => ({ id: String(route.params.id) }),
    },
  ],
})

router.beforeEach(async (to) => {
  const token = await getAuthToken()
  const isAuthed = !!token

  if (to.meta.requiresAuth && !isAuthed) {
    return { name: 'login' }
  }

  if (to.name === 'login' && isAuthed) {
    return { name: 'dashboard' }
  }
})

export default router
